import { CountryState } from '../../../common/components/SearchHeader/constants';
import { FilterChoice } from '../../../common/components/SearchHeader/types/FilterChoice';
import { SuburbChoice } from '../../../common/components/SearchHeader/types/LocationChoice';
import { useHannibalQuery } from '../../../common/schema/hannibal/HannibalContext';
import { NearbySuburbsDocument } from '../../../common/schema/hannibal/types.generated';
import { parseToEnum } from '../../../common/util/parseToEnum';
import { SuburbLinks } from './SuburbLinks';

interface Props {
  suburb: SuburbChoice['suburb'];
  filters: FilterChoice;
  isSidebar?: boolean;
}

export const NearbySuburbLinks = ({ suburb, filters, isSidebar = false }: Props) => {
  const { data } = useHannibalQuery(NearbySuburbsDocument, {
    variables: { state: suburb.state, postcode: suburb.postcode, name: suburb.name ?? '' },
  });

  const locations = (data?.suburb?.nearbySuburbs ?? []).map(suburb => ({
    suburb: {
      name: suburb.name,
      postcode: suburb.postcode,
      state: parseToEnum(suburb.state, CountryState) ?? undefined,
    },
  }));

  return <SuburbLinks filters={filters} locations={locations} isSidebar={isSidebar} />;
};
